// Error messages
export const WHITELIST_ERROR_USER_MULTIPLE_COMPANY =
	'WHITELIST_ERROR_USER_MULTIPLE_COMPANY';

// PDQ Device Settings
export const PDQ_DEVICE_SETTING_HANDEDNESS = 'Handedness';
export const PDQ_DEVICE_SETTING_AUTO_RELOCK_DELAY = 'AutoRelockDelay';
export const PDQ_DEVICE_SETTING_BATTERY_LEVEL = 'BatteryLevel';

// General Device Settings
export const DEVICE_SETTING_AJAX_HUB_ID = 'AJAXHubID';

// Legal / privacy policy (US vs Non-US)
export const NON_US_PRIVACY_POLICY_URL =
	'https://www.keyneticsltd.co.uk/privacy-policy/';
export const US_PRIVACY_POLICY_URL =
	'https://www.keynetics.us/index.php/privacy-policy/';
export const NON_US_TERMS_OF_SERVICE_URL =
	'https://www.keyneticsltd.co.uk/terms-of-use/';
export const US_END_USER_LICENSE_AGREEMENT_URL =
	'https://www.keynetics.us/end-user-license-agreement/';

// Mobile screen width breakpoints
export const MOBILE_BREAKPOINT = 992;
export const MOBILE_SCROLL_THRESCHOLD_WIDTH = 800;

// audit log columns
export const AUDIT_LOG_COLUMN_DATE_TIME = 'dateTime';
export const AUDIT_LOG_COLUMN_PERFORMED_BY_NAME = 'performedByName';
export const AUDIT_LOG_COLUMN_PERFORMED_BY_COMPANY = 'performedByCompany';
export const AUDIT_LOG_COLUMN_USER = 'user';
export const AUDIT_LOG_COLUMN_COMPANY = 'company';
export const AUDIT_LOG_COLUMN_DEVICE = 'device';
export const AUDIT_LOG_COLUMN_DEVICE_GROUP = 'deviceGroup';
export const AUDIT_LOG_COLUMN_PROPERTY = 'property';
export const AUDIT_LOG_COLUMN_DETAILS = 'details';
